import type { SingleValue } from "react-select";

import { SelectInput } from "components/Select";

import { FilterOption, STORE_DEPOSIT_OPTION_LABELS } from "../types";

interface StoreDepositOptionFiltersProps {
  readonly storeOptions: readonly FilterOption[];
  readonly storeCode: number | undefined;
  readonly isStoreLocked: boolean;
  readonly onStoreChange: (storeCode: number | undefined) => void;
}

const findOption = (
  options: readonly FilterOption[],
  value: string | undefined,
): FilterOption | null =>
  options.find((option: FilterOption) => option.value === value) ?? null;

const readOptionValue = (newValue: unknown): string | undefined =>
  (newValue as SingleValue<FilterOption>)?.value ?? undefined;

const fieldLabel = "text-xs text-slate-500 mb-1 block";
const fieldWidth = "w-56";

function RequiredMark() {
  return <span className="text-red-500"> *</span>;
}

export function StoreDepositOptionFilters(props: StoreDepositOptionFiltersProps) {
  const currentStore: FilterOption | null = findOption(
    props.storeOptions,
    props.storeCode === undefined ? undefined : String(props.storeCode),
  );

  const handleStoreChange = (newValue: unknown): void => {
    const value: string | undefined = readOptionValue(newValue);
    const parsed: number = Number(value);
    props.onStoreChange(
      value !== undefined && !Number.isNaN(parsed) ? parsed : undefined,
    );
  };

  return (
    <div className="flex flex-wrap items-end gap-4 mt-4">
      <div className={fieldWidth}>
        <label className={fieldLabel}>
          {STORE_DEPOSIT_OPTION_LABELS.storeLabel}
          <RequiredMark />
        </label>
        <SelectInput
          options={props.storeOptions}
          value={currentStore}
          onChange={handleStoreChange}
          isClearable={!props.isStoreLocked}
          isDisabled={props.isStoreLocked}
          placeholder={STORE_DEPOSIT_OPTION_LABELS.storePlaceholder}
        />
      </div>
    </div>
  );
}
